import React from 'react';
import PropTypes from 'prop-types';
import EclipseDot from "../../../assets/images/EllipseDot.png"
import styles from './AdvantageCard.module.scss';

const AdvantageCard = ({ icon, title, description }) => (
  <div className={styles.card}>
    <div className={styles.icon}>
      <img src={EclipseDot} alt={EclipseDot} />
    </div>
    <div className={styles.content}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  </div>
);

AdvantageCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default AdvantageCard;
